var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineStopCircle2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.22 12c0-5.93 4.83-10.75 10.75-10.75S22.72 6.07 22.72 12 17.9 22.75 11.97 22.75C6.05 22.75 1.22 17.93 1.22 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25-4.15-9.25-9.25-9.25S2.72 6.9 2.72 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "         M8.5 6         H15.5         A2.5 2.5 0 0 1 18 8.5         V15.5         A2.5 2.5 0 0 1 15.5 18         H8.5         A2.5 2.5 0 0 1 6 15.5         V8.5         A2.5 2.5 0 0 1 8.5 6         Z         M9.8 7.3         H14.2         A1.9 1.9 0 0 1 16.1 9.2         V14.8         A1.9 1.9 0 0 1 14.2 16.7         H9.8         A1.9 1.9 0 0 1 7.9 14.8         V9.2         A1.9 1.9 0 0 1 9.8 7.3         Z       "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineStopCircle2);
export default __webpack_public_path__ + "static/media/vuesax-outline-stop-circle-2.00a32030259e2e4a0c2022a06099434f.svg";
export { ForwardRef as ReactComponent };